import { type TableHTMLAttributes } from 'react';
import { ListSurface } from './list-surface';
import styles from './table.module.css';

export const tableStyles = styles;

/**
 * Veri tablosu (DataTable kartı, yeni görünüm Aşama 1b) — organizatör paneli
 * gibi veri yoğun ekranlar için.
 *
 * ANATOMİSİ TANIMI GEREĞİ `row`dur (Revizyon 2 §4): tablo toplu tarama
 * yüzeyidir ve xxl'de ızgaraya GEÇMEZ — genişleyen alan kart sayısı değil
 * KOLON geri kazandırır. Bunu tek tek çağıranlara bırakmak yerine bileşen
 * kendi anatomisini bildirir; `ListSurface` sarmalayıcısı `ib-stack-grid`
 * sınıfını ASLA basmaz, dolayısıyla konteyner sorgusu tabloya değmez.
 */
export interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  /**
   * DAR EKRAN BİÇİMİ (DataTable kartı "Telefonda"). `scroll` (varsayılan):
   * tablo yatay kayar, eylem kolonu sağa sabitlenir (kullanıcı kararı
   * 23.10.2026). `list`: telefonda (<768 px) her satır kişi kartına döner
   * (avatar, ad, durum, altında eylemler); kayıt, başvuru ve davet tabloları
   * içindir. Semantik `<table>` aynen kalır, başlık satırı görsel olarak gizlenir.
   */
  readonly narrow?: 'scroll' | 'list';
}

export function Table({ className, children, narrow = 'scroll', ...rest }: TableProps) {
  return (
    <ListSurface anatomy="row" className={styles.wrap}>
      <table
        {...rest}
        data-table-narrow={narrow}
        className={[styles.table, narrow === 'list' ? styles.list : '', className ?? '']
          .filter(Boolean)
          .join(' ')}
      >
        {children}
      </table>
    </ListSurface>
  );
}
